import { StudentAssignmentCard, Text } from 'shell/components';

const assignment = {
    title: 'Assignment Name',
};

const StudentAssignmentCardDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>StudentAssignmentCard</Text>
            <StudentAssignmentCard
                assignment={assignment}
                numAttemptsRemaining={3}
                onClickGetFeedback={console.log}
                onClickViewFeedback={console.log}
            />
            <StudentAssignmentCard
                assignment={assignment}
                numAttemptsRemaining={0}
                onClickGetFeedback={console.log}
                onClickViewFeedback={console.log}
            />
        </>
    );
};

export default StudentAssignmentCardDemo;
